<!-- Header de página -->
<div class="page-header">
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <h1 class="page-title">ÓRDENES DE SERVICIO AGENCIA</h1>
            <p class="page-subtitle text-muted">
                Gestión y consulta de órdenes de servicio para liquidaciones de
                agencia
            </p>
        </div>
        <div class="header-actions">
            <button
                mat-raised-button
                color="primary"
                (click)="exportarExcel()"
                [disabled]="isLoading || isGeneratingExcel"
                matTooltip="Exportar datos actuales a Excel"
            >
                <mat-icon>download</mat-icon>
                Excel
            </button>
        </div>
    </div>
</div>

<!-- Filtros de búsqueda -->
<mat-card class="filters-card">
    <mat-card-header>
        <mat-card-title>
            <mat-icon>filter_list</mat-icon>
            Filtros de Búsqueda
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="filters-section">
            <div class="filters-grid filters-grid-50">
                <!-- Primera fila -->
                <mat-form-field
                    *ngIf="!isClientUser"
                    appearance="outline"
                    class="filter-field"
                >
                    <mat-label>Cliente</mat-label>
                    <input
                        matInput
                        [formControl]="filtroCliente"
                        [matAutocomplete]="autoCliente"
                        [readonly]="filtroCliente.disabled"
                        placeholder="Buscar cliente"
                        inputmode="search"
                    />
                    <mat-autocomplete
                        #autoCliente="matAutocomplete"
                        [displayWith]="displayCliente"
                    >
                        <mat-option [value]="''">Todos los clientes</mat-option>
                        <mat-option
                            *ngFor="let cliente of filteredClientesOptions"
                            [value]="cliente.clienteId"
                        >
                            {{ cliente.cliente }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matSuffix>business</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Servicio</mat-label>
                    <input
                        matInput
                        [formControl]="filtroServicio"
                        [matAutocomplete]="autoServicio"
                        placeholder="Buscar servicio"
                        inputmode="search"
                    />
                    <mat-autocomplete
                        #autoServicio="matAutocomplete"
                        [displayWith]="displayServicio"
                    >
                        <mat-option [value]="''"
                            >Todos los servicios</mat-option
                        >
                        <mat-option
                            *ngFor="let servicio of filteredServiciosOptions"
                            [value]="servicio.serviceId"
                        >
                            {{ servicio.serviceName }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matSuffix>room_service</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Nave</mat-label>
                    <input
                        matInput
                        [formControl]="filtroNave"
                        [matAutocomplete]="autoNave"
                        placeholder="Buscar nave"
                        inputmode="search"
                    />
                    <mat-autocomplete
                        #autoNave="matAutocomplete"
                        [displayWith]="displayNave"
                    >
                        <mat-option [value]="''">Todas las naves</mat-option>
                        <mat-option
                            *ngFor="let nave of filteredNavesOptions"
                            [value]="nave.vesselId"
                        >
                            {{ nave.vesselName }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matSuffix>directions_boat</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Tipo Facturación</mat-label>
                    <mat-select [formControl]="filtroTipoFacturacion">
                        <mat-option [value]="null">Todos los tipos</mat-option>
                        <mat-option
                            *ngFor="let tipo of tiposFacturacionOptions"
                            [value]="tipo.typeOfInvoicingId"
                            >{{ tipo.typeOfInvoicingName }}</mat-option
                        >
                    </mat-select>
                    <mat-icon matSuffix>receipt</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Temporada</mat-label>
                    <mat-select [formControl]="filtroTemporada">
                        <mat-option [value]="null"
                            >Todas las temporadas</mat-option
                        >
                        <mat-option
                            *ngFor="let temporada of temporadasOptions"
                            [value]="temporada.seasonId"
                        >
                            {{ temporada.seasonName }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>date_range</mat-icon>
                </mat-form-field>

                <!-- Segunda fila -->
                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Inicio</mat-label>
                    <input
                        matInput
                        [matDatepicker]="pickerInicio"
                        [formControl]="filtroInicio"
                        placeholder="Seleccionar fecha"
                        inputmode="none"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="pickerInicio"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pickerInicio></mat-datepicker>
                    <mat-hint *ngIf="datesLockedBySearch">No disponible con Contenedor/DUS/Liquidación/Booking</mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Fin</mat-label>
                    <input
                        matInput
                        [matDatepicker]="pickerFin"
                        [formControl]="filtroFin"
                        placeholder="Seleccionar fecha"
                        inputmode="none"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="pickerFin"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pickerFin></mat-datepicker>
                    <mat-hint *ngIf="datesLockedBySearch">No disponible con Contenedor/DUS/Liquidación/Booking</mat-hint>
                </mat-form-field>

                <!-- Tercera fila - campos de texto según wireframe -->
                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Ref. Cliente</mat-label>
                    <input
                        matInput
                        [formControl]="filtroRefCliente"
                        placeholder="Referencia del cliente"
                        inputmode="text"
                    />
                    <mat-icon matSuffix>assignment</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Contenedor</mat-label>
                    <input
                        matInput
                        [formControl]="filtroContenedor"
                        placeholder="Número de contenedor"
                        inputmode="text"
                    />
                    <mat-icon matSuffix>inventory_2</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>DUS</mat-label>
                    <input
                        matInput
                        [formControl]="filtroDus"
                        placeholder="Número DUS"
                        inputmode="text"
                    />
                    <mat-icon matSuffix>description</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Nro Liquidación</mat-label>
                    <input
                        matInput
                        [formControl]="filtroNroLiquidacion"
                        placeholder="Número de liquidación"
                        inputmode="numeric"
                    />
                    <mat-icon matSuffix>receipt_long</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Booking</mat-label>
                    <input
                        matInput
                        [formControl]="filtroBooking"
                        placeholder="Número de booking"
                        inputmode="text"
                    />
                    <mat-icon matSuffix>confirmation_number</mat-icon>
                </mat-form-field>
            </div>

            <!-- Botones de acción -->
            <div class="filter-actions">
                <button
                    mat-raised-button
                    color="primary"
                    (click)="aplicarFiltros()"
                    [disabled]="isLoading"
                    matTooltip="Buscar con los filtros aplicados"
                >
                    <mat-icon>search</mat-icon>
                    Buscar
                </button>
                <button
                    mat-raised-button
                    color="warn"
                    (click)="limpiarFiltros()"
                    [disabled]="!hasActiveFilters() || isLoading"
                    matTooltip="Limpiar todos los filtros"
                >
                    <mat-icon>clear</mat-icon>
                    Limpiar
                </button>
            </div>

            <!-- Indicador de filtros activos -->
            <div class="filter-chips" *ngIf="hasActiveFilters()">
                <mat-chip-set>
                    <mat-chip
                        *ngIf="filtroTemporada.value"
                        removable
                        (removed)="filtroTemporada.setValue(null)"
                    >
                        Temporada:
                        {{ getTemporadaNombre(filtroTemporada.value) }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <mat-chip
                        *ngIf="filtroRefCliente.value"
                        removable
                        (removed)="filtroRefCliente.setValue('')"
                    >
                        Ref. Cliente: {{ filtroRefCliente.value }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <mat-chip
                        *ngIf="filtroContenedor.value"
                        removable
                        (removed)="filtroContenedor.setValue('')"
                    >
                        Contenedor: {{ filtroContenedor.value }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <mat-chip
                        *ngIf="filtroBooking.value"
                        removable
                        (removed)="filtroBooking.setValue('')"
                    >
                        Booking: {{ filtroBooking.value }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <mat-chip
                        *ngIf="filtroNroLiquidacion.value"
                        removable
                        (removed)="filtroNroLiquidacion.setValue('')"
                    >
                        Liquidación: {{ filtroNroLiquidacion.value }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-set>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<!-- Tabs de órdenes de servicio -->
<mat-card class="data-card">
    <mat-tab-group
        [(selectedIndex)]="selectedTabIndex"
        (selectedTabChange)="onTabChange($event)"
        animationDuration="200ms"
        class="os-agencia-tabs"
    >
        <mat-tab *ngFor="let tab of tabs; let i = index" [label]="tab.label">
            <ng-template mat-tab-label>
                <div class="tab-label">
                    <mat-icon>{{ tab.icon }}</mat-icon>
                    <span class="tab-text">{{ tab.label }}</span>
                    <span
                        class="tab-count"
                        *ngIf="getTabBadgeCount(tab.type) > 0"
                    >
                        ({{ getTabBadgeCount(tab.type) }})
                    </span>
                </div>
            </ng-template>

            <!-- Contenido del tab -->
            <div class="tab-content">
                <!-- Descripción del tab -->
                <div class="tab-description">
                    <mat-icon class="description-icon">info</mat-icon>
                    <span>{{ tab.description }}</span>
                </div>

                <!-- Estado de carga -->
                <div *ngIf="isLoading" class="loading-container">
                    <mat-spinner diameter="40"></mat-spinner>
                    <p>Cargando órdenes de servicio...</p>
                </div>

                <!-- Error state -->
                <div *ngIf="hasError && !isLoading" class="error-container">
                    <mat-icon color="warn">error</mat-icon>
                    <h3>Error al cargar datos</h3>
                    <p>{{ errorMessage }}</p>
                    <button
                        mat-raised-button
                        color="primary"
                        (click)="buscarOrdenes()"
                    >
                        <mat-icon>refresh</mat-icon>
                        Reintentar
                    </button>
                </div>

                <!-- Tabla de datos -->
                <div
                    *ngIf="!isLoading && !hasError"
                    class="liquidaciones-list-table table-container"
                >
                    <!-- Información de resultados -->
                    <div class="results-info">
                        <span class="total-records">
                            Total: <strong>{{ totalRegistros }}</strong> órdenes
                        </span>
                        <span class="page-info" *ngIf="totalPaginas > 1">
                            (Página {{ paginaActual }} de {{ totalPaginas }})
                        </span>
                    </div>

                    <!-- Tabla -->
                    <div class="table-wrapper table-responsive">
                        <table
                            mat-table
                            [dataSource]="dataSource"
                            matSort
                            multiTemplateDataRows
                        >
                            <!-- Columna Nro O/S -->
                            <ng-container matColumnDef="nroOs">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header="id"
                                >
                                    Nro O/S
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <strong class="os-number">{{
                                        orden.id
                                    }}</strong>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    <strong>TOTALES</strong>
                                </td>
                            </ng-container>

                            <!-- Columna Nro Liquidación -->
                            <ng-container matColumnDef="nroLiquidacion">
                                <th mat-header-cell *matHeaderCellDef>
                                    Nro Liquidación
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <span class="liquidacion-number">{{
                                        orden.numeroLiquidacion
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    {{ totales.count }} registros
                                </td>
                            </ng-container>

                            <!-- Columna Cliente -->
                            <ng-container matColumnDef="cliente">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header="customerName"
                                >
                                    Cliente
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <span class="customer-name">{{
                                        orden.customerName
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    —
                                </td>
                            </ng-container>

                            <!-- Columna Servicio -->
                            <ng-container matColumnDef="servicio">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header="serviceName"
                                >
                                    Servicio
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <span class="service-name">{{
                                        orden.serviceName
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    —
                                </td>
                            </ng-container>

                            <!-- Columna Nave -->
                            <ng-container matColumnDef="nave">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header="vesselName"
                                >
                                    Nave
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <span class="vessel-name">{{
                                        orden.vesselName
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    —
                                </td>
                            </ng-container>

                            <!-- Columna ETD -->
                            <ng-container matColumnDef="inicio">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header="etdDate"
                                >
                                    ETD
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <span class="date-cell">{{
                                        orden.formattedEtd
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    —
                                </td>
                            </ng-container>

                            <!-- Columna POD -->
                            <ng-container matColumnDef="fin">
                                <th mat-header-cell *matHeaderCellDef>POD</th>
                                <td mat-cell *matCellDef="let orden">
                                    <span class="port-name">{{
                                        orden.portOfDischargeName || 'N/A'
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    —
                                </td>
                            </ng-container>

                            <!-- Columna Tipo Facturación -->
                            <ng-container matColumnDef="tipoFacturacion">
                                <th mat-header-cell *matHeaderCellDef>
                                    Tipo Facturación
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <mat-chip
                                        [class]="
                                            'chip-' +
                                            (orden.typeOfInvoicingName
                                                | lowercase)
                                        "
                                        class="invoicing-chip"
                                    >
                                        {{ orden.typeOfInvoicingName }}
                                    </mat-chip>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    —
                                </td>
                            </ng-container>

                            <!-- Columna Ref. Cliente -->
                            <ng-container matColumnDef="refCliente">
                                <th mat-header-cell *matHeaderCellDef>
                                    Ref. Cliente
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <span class="customer-ref">{{
                                        orden.customerReference || 'N/A'
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    —
                                </td>
                            </ng-container>

                            <!-- Columna Booking -->
                            <ng-container matColumnDef="booking">
                                <th mat-header-cell *matHeaderCellDef>
                                    Booking
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <span class="booking-number">{{
                                        orden.bookingNumber || 'N/A'
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    —
                                </td>
                            </ng-container>

                            <!-- Columna Contenedor -->
                            <ng-container matColumnDef="contenedor">
                                <th mat-header-cell *matHeaderCellDef>
                                    Contenedor
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <span class="container-number">{{
                                        orden.containerNumber || 'N/A'
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    —
                                </td>
                            </ng-container>

                            <!-- Columna Nro DUS -->
                            <ng-container matColumnDef="nroDus">
                                <th mat-header-cell *matHeaderCellDef>
                                    Nro DUS
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <span>{{
                                        orden.dusNumber || '-'
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    —
                                </td>
                            </ng-container>

                            <!-- Columna Venta Neta -->
                            <ng-container matColumnDef="ventaNeta">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header="totalSellingPriceAmount"
                                >
                                    Venta Neta
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let orden"
                                    class="amount-cell"
                                >
                                    <span class="amount-value">{{
                                        formatMonto(
                                            orden.totalSellingPriceAmount
                                        )
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell amount-cell"
                                >
                                    <strong class="total-amount">{{
                                        formatMonto(totales.totalVentaNeto)
                                    }}</strong>
                                </td>
                            </ng-container>

                            <!-- Columna Traspaso Bruto -->
                            <ng-container matColumnDef="traspasoBruto">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header="totalManagementFeeAmount"
                                >
                                    Traspaso Bruto
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let orden"
                                    class="amount-cell"
                                >
                                    <span class="amount-value">{{
                                        formatMonto(
                                            orden.totalManagementFeeAmount
                                        )
                                    }}</span>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell amount-cell"
                                >
                                    <strong class="total-amount">{{
                                        formatMonto(totales.totalTraspasoBruto)
                                    }}</strong>
                                </td>
                            </ng-container>

                            <!-- Columna Acciones -->
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef>
                                    ACCIONES
                                </th>
                                <td mat-cell *matCellDef="let orden">
                                    <div class="action-buttons">
                                        <button
                                            mat-button
                                            color="primary"
                                            (click)="verOrden(orden, $event)"
                                            matTooltip="Ver detalle de la orden"
                                            class="action-btn view-btn"
                                        >
                                            VER
                                        </button>
                                        <button
                                            mat-button
                                            color="accent"
                                            (click)="descargarDocumento(orden)"
                                            matTooltip="Descargar documento"
                                            class="action-btn doc-btn"
                                        >
                                            DOC
                                        </button>
                                    </div>
                                </td>
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    class="totales-cell"
                                >
                                    <strong class="total-amount grand-total">
                                        {{ formatMonto(totales.totalGeneral) }}
                                    </strong>
                                </td>
                            </ng-container>

                            <!-- Filas de la tabla -->
                            <tr
                                mat-header-row
                                *matHeaderRowDef="displayedColumns"
                            ></tr>
                            <tr
                                mat-row
                                *matRowDef="let row; columns: displayedColumns"
                                class="data-row"
                            ></tr>
                            <tr
                                mat-footer-row
                                *matFooterRowDef="displayedColumns"
                                class="totales-row"
                            ></tr>
                        </table>
                    </div>

                    <!-- Sin datos -->
                    <div *ngIf="dataSource.data.length === 0" class="no-data">
                        <mat-icon>search_off</mat-icon>
                        <h3>No hay órdenes de servicio</h3>
                        <p>
                            No se encontraron órdenes que coincidan con los
                            filtros aplicados.
                        </p>
                        <button
                            mat-raised-button
                            color="primary"
                            (click)="limpiarFiltros()"
                        >
                            <mat-icon>clear</mat-icon>
                            Limpiar filtros
                        </button>
                    </div>

                    <!-- Paginador -->
                    <mat-paginator
                        *ngIf="totalRegistros > 0"
                        #paginator
                        [length]="totalRegistros"
                        [pageSize]="elementosPorPagina"
                        [pageSizeOptions]="[10, 25, 50, 100]"
                        [pageIndex]="paginaActual - 1"
                        [showFirstLastButtons]="true"
                        [hidePageSize]="false"
                        [disabled]="isLoading"
                        (page)="onPageChange($event)"
                        aria-label="Seleccionar página"
                        class="os-agencia-paginator"
                    >
                    </mat-paginator>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-card>

<!-- Overlay de carga para generación de Excel -->
<div *ngIf="isGeneratingExcel" class="excel-loading-overlay">
    <div class="excel-loading-content">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="excel-loading-text">Generando Archivo Excel...</p>
    </div>
</div>
